export const ai = {
  extends: 'Page',
  flow: 'x',
  minHeight: '100vh',
  background: 'ink',
  color: 'inkText',
  NavSidebar: {},
  TabInit: { display: 'none', show: (() => { let d = false; return (el, s) => { if (!d) { d = true; Promise.resolve().then(() => s.root.update({ activeTab: 'ai' })) } return false } })() },

  MainContent: {
    flow: 'y',
    flex: '1',
    overflow: 'auto',

    TopBar: {},

    ContentArea: {
      flow: 'y',
      gap: 'B',
      padding: 'B',
      flex: '1',
      '@mobileL': { padding: 'A' },

      // ─── AI TOOL TABS ──────────────────────────
      AiToolTabs: {
        flow: 'x',
        gap: 'Z',
        borderBottom: '1px solid inkBorder',
        paddingBottom: 'Y',
        TabAssistant: {
          flow: 'x', gap: 'Y', align: 'center flex-start',
          text: '{{ aiAssistant | polyglot }}',
          fontSize: 'Z',
          fontWeight: '600',
          padding: 'Y Z',
          cursor: 'pointer',
          color: (el, s) => s.root.activeAiTool === 'assistant' ? 'purple' : 'inkMuted',
          borderBottom: (el, s) => s.root.activeAiTool === 'assistant' ? '2px solid purple' : '2px solid transparent',
          onClick: (e, el, s) => s.root.update({ activeAiTool: 'assistant' })
        },
        TabXray: {
          text: '{{ xrayAnalysis | polyglot }}',
          fontSize: 'Z',
          fontWeight: '600',
          padding: 'Y Z',
          cursor: 'pointer',
          color: (el, s) => s.root.activeAiTool === 'xray' ? 'purple' : 'inkMuted',
          borderBottom: (el, s) => s.root.activeAiTool === 'xray' ? '2px solid purple' : '2px solid transparent',
          onClick: (e, el, s) => s.root.update({ activeAiTool: 'xray' })
        },
        TabNotes: {
          text: '{{ notesTab | polyglot }}',
          fontSize: 'Z',
          fontWeight: '600',
          padding: 'Y Z',
          cursor: 'pointer',
          color: (el, s) => s.root.activeAiTool === 'notes' ? 'purple' : 'inkMuted',
          borderBottom: (el, s) => s.root.activeAiTool === 'notes' ? '2px solid purple' : '2px solid transparent',
          onClick: (e, el, s) => s.root.update({ activeAiTool: 'notes' })
        },
        TabPerioAi: {
          text: '{{ perioAssessment | polyglot }}',
          fontSize: 'Z',
          fontWeight: '600',
          padding: 'Y Z',
          cursor: 'pointer',
          color: (el, s) => s.root.activeAiTool === 'perio-ai' ? 'purple' : 'inkMuted',
          borderBottom: (el, s) => s.root.activeAiTool === 'perio-ai' ? '2px solid purple' : '2px solid transparent',
          onClick: (e, el, s) => s.root.update({ activeAiTool: 'perio-ai' })
        },
        TabRisk: {
          text: '{{ aiRiskAssessment | polyglot }}',
          fontSize: 'Z',
          fontWeight: '600',
          padding: 'Y Z',
          cursor: 'pointer',
          color: (el, s) => s.root.activeAiTool === 'risk' ? 'purple' : 'inkMuted',
          borderBottom: (el, s) => s.root.activeAiTool === 'risk' ? '2px solid purple' : '2px solid transparent',
          onClick: (e, el, s) => s.root.update({ activeAiTool: 'risk' })
        },
        TabComm: {
          text: '{{ patientCommunication | polyglot }}',
          fontSize: 'Z',
          fontWeight: '600',
          padding: 'Y Z',
          cursor: 'pointer',
          color: (el, s) => s.root.activeAiTool === 'comm' ? 'purple' : 'inkMuted',
          borderBottom: (el, s) => s.root.activeAiTool === 'comm' ? '2px solid purple' : '2px solid transparent',
          onClick: (e, el, s) => s.root.update({ activeAiTool: 'comm' })
        }
      },

      // ─── AI ASSISTANT ──────────────────────────
      AiAssistantTool: {
        flow: 'y',
        gap: 'A',
        flex: '1',
        show: (el, s) => s.root.activeAiTool === 'assistant',

        MessageList: {
          flow: 'y',
          gap: 'A',
          flex: '1',
          overflow: 'auto',
          padding: 'A 0',
          children: (el, s) => s.root.messages,
          childExtends: {
            flow: 'y',
            gap: 'Y',
            padding: 'A',
            round: 'A',
            maxWidth: '80%',
            background: (el, s) => s.role === 'user' ? 'teal.12' : 'inkMid',
            alignSelf: (el, s) => s.role === 'user' ? 'flex-end' : 'flex-start',
            border: (el, s) => s.role === 'user' ? '1px solid teal.2' : '1px solid inkBorder',
            RoleLabel: {
              text: (el, s) => s.role === 'user' ? 'You' : 'AI Assistant',
              fontSize: 'Y',
              fontWeight: '600',
              color: (el, s) => s.role === 'user' ? 'teal' : 'purple'
            },
            MessageContent: {
              html: (el, s) => s.content
                .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
                .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
                .replace(/\n/g, '<br>'),
              fontSize: 'Z',
              color: 'inkText',
              lineHeight: '1.6'
            }
          },
          childrenAs: 'state'
        },

        TypingIndicator: {
          show: (el, s) => s.root.isTyping,
          text: '{{ aiThinking | polyglot }}',
          fontSize: 'Y',
          color: 'purple',
          fontWeight: '500',
          padding: 'Y 0'
        },

        SuggestionRow: {
          flow: 'x',
          gap: 'Y',
          flexWrap: 'wrap',
          padding: 'Y 0',
          ChipOne: {
            text: '{{ summarizeHistory | polyglot }}',
            fontSize: 'Y',
            padding: 'Y Z',
            round: 'B',
            background: 'purple.1',
            color: 'purple',
            border: '1px solid purple.2',
            cursor: 'pointer',
            fontWeight: '500',
            onClick: (e, el, s) => {
              const updated = [...s.root.messages, { role: 'user', content: 'Summarize patient history' }]
              s.root.update({ messages: updated })
            }
          },
          ChipTwo: {
            text: '{{ generateTxPlan | polyglot }}',
            fontSize: 'Y',
            padding: 'Y Z',
            round: 'B',
            background: 'purple.1',
            color: 'purple',
            border: '1px solid purple.2',
            cursor: 'pointer',
            fontWeight: '500',
            onClick: (e, el, s) => {
              const updated = [...s.root.messages, { role: 'user', content: 'Generate treatment plan' }]
              s.root.update({ messages: updated })
            }
          },
          ChipThree: {
            text: '{{ checkDrugInteractions | polyglot }}',
            fontSize: 'Y',
            padding: 'Y Z',
            round: 'B',
            background: 'purple.1',
            color: 'purple',
            border: '1px solid purple.2',
            cursor: 'pointer',
            fontWeight: '500',
            onClick: (e, el, s) => {
              const updated = [...s.root.messages, { role: 'user', content: 'Check drug interactions' }]
              s.root.update({ messages: updated })
            }
          },
          ChipFour: {
            text: '{{ writeClinicalNote | polyglot }}',
            fontSize: 'Y',
            padding: 'Y Z',
            round: 'B',
            background: 'purple.1',
            color: 'purple',
            border: '1px solid purple.2',
            cursor: 'pointer',
            fontWeight: '500',
            onClick: (e, el, s) => {
              const updated = [...s.root.messages, { role: 'user', content: 'Write clinical note' }]
              s.root.update({ messages: updated })
            }
          }
        },

        ChatInputRow: {
          flow: 'x',
          gap: 'Z',
          align: 'center center',
          padding: 'Y 0',
          ChatInput: {
            extends: 'Input',
            tag: 'input',
            type: 'text',
            placeholder: '{{ askAiAssistant | polyglot }}',
            padding: 'Z A',
            round: 'A',
            background: 'inkSurface',
            color: 'inkText',
            border: '1px solid inkBorder',
            fontSize: 'Z',
            flex: '1'
          },
          SendBtn: {
            extends: 'Button',
            flow: 'x',
            align: 'center center',
            gap: 'Y',
            background: '#0D1117',
            color: '#FFFFFF',
            fontWeight: '600',
            padding: 'Z A',
            round: 'A',
            fontSize: 'Z',
            cursor: 'pointer',
            border: 'none',
            SendIcon: { extends: 'Icon', icon: 'send', width: 'Z', height: 'Z' },
            SendLabel: { text: '{{ send | polyglot }}' },
            onClick: async (e, el, s) => {
              const input = el.lookup('ChatInput')
              const msg = input.node.value
              if (!msg.trim()) return
              input.node.value = ''
              const updated = [...s.root.messages, { role: 'user', content: msg }]
              s.root.update({ messages: updated, isTyping: true })
              try {
                const res = await fetch('https://generativelanguage.googleapis.com/v1beta/models/gemini-3.1-flash-lite-preview:generateContent?key=AIzaSyC0Y2BcOff1cLeSxuU0jlXFbiPfGraZfJc', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({
                    systemInstruction: { parts: [{ text: 'You are a dental clinical assistant for Georgian dental clinics. Help dentists with treatment planning, clinical notes, drug interactions, and patient communication. You speak Georgian and English. Be concise and clinically accurate. Use Georgian medical terminology when appropriate.' }] },
                    contents: updated.map(m => ({ role: m.role === 'assistant' ? 'model' : 'user', parts: [{ text: m.content }] }))
                  })
                })
                const data = await res.json()
                const reply = data.candidates?.[0]?.content?.parts?.[0]?.text || 'No response'
                s.root.update({ messages: [...updated, { role: 'assistant', content: reply }], isTyping: false })
              } catch (err) {
                s.root.update({ messages: [...updated, { role: 'assistant', content: 'Error: ' + err.message }], isTyping: false })
              }
            }
          }
        }
      },

      // ─── X-RAY ANALYSIS ────────────────────────
      AiXrayTool: {
        flow: 'y',
        gap: 'A',
        show: (el, s) => s.root.activeAiTool === 'xray',

        UploadZone: {
          flow: 'y',
          align: 'center center',
          gap: 'Z',
          padding: 'D',
          round: 'A',
          border: '2px dashed inkBorder',
          background: 'inkMid',
          cursor: 'pointer',
          UploadIcon: { extends: 'Icon', icon: 'upload', width: 'C', height: 'C', color: 'teal' },
          UploadText: { text: '{{ dropXray | polyglot }}', fontSize: 'Z', color: 'inkMuted', textAlign: 'center' },
          UploadHint: { text: '{{ supportsFormats | polyglot }}', fontSize: 'Y', color: 'inkMuted' }
        },

        AnalysisResults: {
          flow: 'y', gap: 'Z', marginTop: 'A',
          ResultsTitle: { text: '{{ analysisResults | polyglot }}', fontSize: 'A', fontWeight: '700', color: 'inkText', marginBottom: 'Y' },

          Finding1: {
            extends: 'AiInsightCard',
            state: { insight: 'Periapical radiolucency detected at tooth #14 apex. Approximately 3mm diameter. Consistent with chronic periapical abscess.', confidence: '92' }
          },
          Finding2: {
            extends: 'AiInsightCard',
            state: { insight: 'Mesial caries detected on tooth #36. Early dentin involvement. Recommend composite restoration.', confidence: '87' }
          },
          Finding3: {
            extends: 'AiInsightCard',
            state: { insight: 'Mild horizontal bone loss in posterior mandibular region. Monitor at next recall visit.', confidence: '78' }
          },

          RecommendationBox: {
            flow: 'y', gap: 'Z', padding: 'A', round: 'A', background: 'inkMid', border: '1px solid purple',
            RecTitle: { text: '{{ aiRecommendation | polyglot }}', fontSize: 'Z', fontWeight: '700', color: 'purple' },
            RecText: { text: '{{ priorityCompleteRctOn | polyglot }}', fontSize: 'Z', color: 'inkSubtle', lineHeight: '1.6' }
          },

          ExportBtn: { extends: 'Button', text: '{{ exportToTxPlan | polyglot }}', marginTop: 'Z', background: 'teal', color: 'ink', fontWeight: '600', padding: 'Z A', round: 'A', fontSize: 'Z', cursor: 'pointer', border: 'none' }
        }
      },

      // ─── CLINICAL NOTES ────────────────────────
      AiNotesTool: {
        flow: 'y',
        gap: 'A',
        show: (el, s) => s.root.activeAiTool === 'notes',

        NotesForm: {
          flow: 'y', gap: 'Z', padding: 'B', round: 'A', background: 'inkMid', border: '1px solid inkBorder',

          FieldPatient: {
            flow: 'y', gap: 'Y',
            FieldLabel: { tag: 'label', text: '{{ patientName | polyglot }}', fontSize: 'Z', fontWeight: '500', color: 'inkMuted' },
            FieldInput: { extends: 'Input', tag: 'input', type: 'text', placeholder: 'e.g. Giorgi Beridze', padding: 'Z A', round: 'A', background: 'inkSurface', color: 'inkText', border: '1px solid inkBorder', fontSize: 'Z', width: '100%' }
          },
          FieldProcedure: {
            flow: 'y', gap: 'Y',
            FieldLabel: { tag: 'label', text: '{{ procedure | polyglot }}', fontSize: 'Z', fontWeight: '500', color: 'inkMuted' },
            FieldInput: { extends: 'Input', tag: 'input', type: 'text', placeholder: 'e.g. Root Canal Treatment', padding: 'Z A', round: 'A', background: 'inkSurface', color: 'inkText', border: '1px solid inkBorder', fontSize: 'Z', width: '100%' }
          },
          FieldObservations: {
            flow: 'y', gap: 'Y',
            FieldLabel: { tag: 'label', text: '{{ observations | polyglot }}', fontSize: 'Z', fontWeight: '500', color: 'inkMuted' },
            FieldTextarea: { extends: 'Input', tag: 'textarea', placeholder: 'Clinical observations, findings, measurements...', padding: 'Z A', round: 'A', background: 'inkSurface', color: 'inkText', border: '1px solid inkBorder', fontSize: 'Z', width: '100%', minHeight: 'E', resize: 'vertical' }
          },
          GenerateBtn: { extends: 'Button', text: '{{ generateClinicalNote | polyglot }}', marginTop: 'Y', background: 'teal', color: 'ink', fontWeight: '600', padding: 'Z A', round: 'A', fontSize: 'Z', cursor: 'pointer', border: 'none' }
        },

        GeneratedNote: {
          flow: 'y', gap: 'Z', padding: 'B', round: 'A', background: 'inkSurface', border: '1px solid inkBorder', marginTop: 'A',

          NoteHeader: { flow: 'x', align: 'center space-between', NoteTitle: { text: '{{ generatedSoap | polyglot }}', fontSize: 'A', fontWeight: '700', color: 'inkText' }, NoteDate: { text: 'Mar 18, 2026', fontSize: 'Y', color: 'inkMuted' } },

          SoapSubjective: {
            flow: 'y', gap: 'X', marginTop: 'Z',
            SoapLabel: { text: '{{ subjective | polyglot }}', fontSize: 'Z', fontWeight: '700', color: 'teal' },
            SoapText: { text: '{{ patientReportsPersistentDull | polyglot }}', fontSize: 'Z', color: 'inkSubtle', lineHeight: '1.5' }
          },
          SoapObjective: {
            flow: 'y', gap: 'X', marginTop: 'Z',
            SoapLabel: { text: '{{ objective | polyglot }}', fontSize: 'Z', fontWeight: '700', color: 'teal' },
            SoapText: { text: '{{ tooth14PositivePercussion | polyglot }}', fontSize: 'Z', color: 'inkSubtle', lineHeight: '1.5' }
          },
          SoapAssessment: {
            flow: 'y', gap: 'X', marginTop: 'Z',
            SoapLabel: { text: '{{ assessment | polyglot }}', fontSize: 'Z', fontWeight: '700', color: 'teal' },
            SoapText: { text: '{{ chronicPeriapicalAbscess14 | polyglot }}', fontSize: 'Z', color: 'inkSubtle', lineHeight: '1.5' }
          },
          SoapPlan: {
            flow: 'y', gap: 'X', marginTop: 'Z',
            SoapLabel: { text: '{{ plan | polyglot }}', fontSize: 'Z', fontWeight: '700', color: 'teal' },
            SoapText: { text: 'Initiate RCT #14. Access cavity prepared. Working length determined (21mm). Canals irrigated with 2.5% NaOCl. Calcium hydroxide intracanal dressing placed. Temporary restoration with Cavit. Review in 2 weeks for obturation. Note: Patient allergic to Penicillin — prescribe Clindamycin 300mg QID x 5 days if infection develops.', fontSize: 'Z', color: 'inkSubtle', lineHeight: '1.5' }
          },

          CopyBtn: { extends: 'Button', text: '{{ copyToRecord | polyglot }}', marginTop: 'A', background: 'inkMid', color: 'inkText', fontWeight: '600', padding: 'Z A', round: 'A', fontSize: 'Z', cursor: 'pointer', border: '1px solid inkBorder' }
        }
      },

      // ─── PERIO AI ASSESSMENT ──────────────────
      AiPerioTool: {
        flow: 'y', gap: 'A',
        show: (el, s) => s.root.activeAiTool === 'perio-ai',
        PerioAiTitle: { tag: 'h2', text: '{{ aiPerioAssessment | polyglot }}', fontSize: 'B', fontWeight: '700', color: 'inkText' },
        PerioAiDesc: { text: '{{ enterProbingData | polyglot }}', fontSize: 'Z', color: 'inkMuted', lineHeight: '1.5' },
        PerioInputArea: {
          flow: 'y', gap: 'Z', padding: 'A', round: 'A', background: 'inkMid', border: '1px solid inkBorder',
          PerioTextarea: { extends: 'Input', tag: 'textarea', placeholder: 'Enter probing depths, BOP sites, and clinical findings...', padding: 'Z A', round: 'A', background: 'inkSurface', color: 'inkText', border: '1px solid inkBorder', fontSize: 'Z', width: '100%', minHeight: 'E', resize: 'vertical' },
          AnalyzePerioBtn: {
            extends: 'Button', text: '{{ analyzeWithGemini | polyglot }}', background: 'purple', color: 'white', fontWeight: '600', padding: 'Z A', round: 'A', fontSize: 'Z', cursor: 'pointer', border: 'none', marginTop: 'Y',
            onClick: async (e, el, s) => {
              var textarea = el.lookup('PerioTextarea')
              var input = textarea.node.value
              if (!input.trim()) return
              s.root.update({ isTyping: true })
              try {
                var res = await fetch('https://generativelanguage.googleapis.com/v1beta/models/gemini-3.1-flash-lite-preview:generateContent?key=AIzaSyC0Y2BcOff1cLeSxuU0jlXFbiPfGraZfJc', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({
                    systemInstruction: { parts: [{ text: 'You are a periodontal assessment AI. Analyze the provided probing data, bleeding indices, and attachment levels. Classify using the 2017 AAP/EFP staging and grading system. Identify sites showing progression vs prior exam. Recommend treatment. Be concise and clinically specific.' }] },
                    contents: [{ role: 'user', parts: [{ text: input }] }]
                  })
                })
                var data = await res.json()
                var reply = data.candidates?.[0]?.content?.parts?.[0]?.text || 'No response'
                s.root.update({ perioAiResult: reply, isTyping: false })
              } catch (err) {
                s.root.update({ perioAiResult: 'Error: ' + err.message, isTyping: false })
              }
            }
          }
        },
        PerioAiResult: {
          show: (el, s) => s.root.perioAiResult,
          extends: 'AiInsightCard',
          state: { insight: (el, s) => s.root.perioAiResult || '', confidence: '89' }
        }
      },

      // ─── RISK ASSESSMENT ──────────────────────
      AiRiskTool: {
        flow: 'y', gap: 'A',
        show: (el, s) => s.root.activeAiTool === 'risk',
        RiskTitle: { tag: 'h2', text: '{{ aiRiskAssessment | polyglot }}', fontSize: 'B', fontWeight: '700', color: 'inkText' },
        RiskDesc: { text: '{{ enterConditions | polyglot }}', fontSize: 'Z', color: 'inkMuted', lineHeight: '1.5' },
        RiskInputArea: {
          flow: 'y', gap: 'Z', padding: 'A', round: 'A', background: 'inkMid', border: '1px solid inkBorder',
          RiskTextarea: { extends: 'Input', tag: 'textarea', placeholder: 'Enter conditions, medications, family history, vitals...', padding: 'Z A', round: 'A', background: 'inkSurface', color: 'inkText', border: '1px solid inkBorder', fontSize: 'Z', width: '100%', minHeight: 'E', resize: 'vertical' },
          AnalyzeRiskBtn: {
            extends: 'Button', text: '{{ generateRiskProfile | polyglot }}', background: 'purple', color: 'white', fontWeight: '600', padding: 'Z A', round: 'A', fontSize: 'Z', cursor: 'pointer', border: 'none', marginTop: 'Y',
            onClick: async (e, el, s) => {
              var textarea = el.lookup('RiskTextarea')
              var input = textarea.node.value
              if (!input.trim()) return
              s.root.update({ isTyping: true })
              try {
                var res = await fetch('https://generativelanguage.googleapis.com/v1beta/models/gemini-3.1-flash-lite-preview:generateContent?key=AIzaSyC0Y2BcOff1cLeSxuU0jlXFbiPfGraZfJc', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({
                    systemInstruction: { parts: [{ text: 'You are a dental risk assessment AI. Given the patient conditions, family history, medications, and vitals, generate a comprehensive dental risk profile. Assess risks for: caries, periodontal disease, oral cancer, endodontic complications, and medication-related issues. Use evidence-based risk factors. Be concise and clinically specific.' }] },
                    contents: [{ role: 'user', parts: [{ text: input }] }]
                  })
                })
                var data = await res.json()
                var reply = data.candidates?.[0]?.content?.parts?.[0]?.text || 'No response'
                s.root.update({ riskAiResult: reply, isTyping: false })
              } catch (err) {
                s.root.update({ riskAiResult: 'Error: ' + err.message, isTyping: false })
              }
            }
          }
        },
        RiskAiResult: {
          show: (el, s) => s.root.riskAiResult,
          extends: 'AiInsightCard',
          state: { insight: (el, s) => s.root.riskAiResult || '', confidence: '85' }
        }
      },

      // ─── PATIENT COMMUNICATION ────────────────
      AiCommTool: {
        flow: 'y', gap: 'A',
        show: (el, s) => s.root.activeAiTool === 'comm',
        CommTitle: { tag: 'h2', text: '{{ patientCommunication | polyglot }}', fontSize: 'B', fontWeight: '700', color: 'inkText' },
        CommDesc: { text: '{{ generateExplanations | polyglot }}', fontSize: 'Z', color: 'inkMuted', lineHeight: '1.5' },
        CommInputArea: {
          flow: 'y', gap: 'Z', padding: 'A', round: 'A', background: 'inkMid', border: '1px solid inkBorder',
          CommTextarea: { extends: 'Input', tag: 'textarea', placeholder: 'Describe the treatment plan or clinical finding to explain to the patient...', padding: 'Z A', round: 'A', background: 'inkSurface', color: 'inkText', border: '1px solid inkBorder', fontSize: 'Z', width: '100%', minHeight: 'E', resize: 'vertical' },
          LangToggle: {
            flow: 'x', gap: 'Y', marginTop: 'Y',
            LangKa: { tag: 'button', text: 'ქართული', padding: 'Y Z', round: 'C', background: 'teal', color: 'ink', fontSize: 'Y', fontWeight: '500', cursor: 'pointer', border: 'none' },
            LangEn: { tag: 'button', text: '{{ english | polyglot }}', padding: 'Y Z', round: 'C', background: 'inkSurface', color: 'inkMuted', fontSize: 'Y', fontWeight: '500', cursor: 'pointer', border: 'none' }
          },
          GenerateCommBtn: {
            extends: 'Button', text: '{{ generateExplanation | polyglot }}', background: 'purple', color: 'white', fontWeight: '600', padding: 'Z A', round: 'A', fontSize: 'Z', cursor: 'pointer', border: 'none', marginTop: 'Y',
            onClick: async (e, el, s) => {
              var textarea = el.lookup('CommTextarea')
              var input = textarea.node.value
              if (!input.trim()) return
              s.root.update({ isTyping: true })
              try {
                var res = await fetch('https://generativelanguage.googleapis.com/v1beta/models/gemini-3.1-flash-lite-preview:generateContent?key=AIzaSyC0Y2BcOff1cLeSxuU0jlXFbiPfGraZfJc', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({
                    systemInstruction: { parts: [{ text: 'You are a dental patient communication assistant. Generate a clear, empathetic, patient-friendly explanation of the dental treatment or finding described. Use simple language, avoid jargon. Respond in Georgian (ქართული) by default. Include: what the issue is, why treatment is needed, what the procedure involves, expected recovery, and approximate cost range in Georgian Lari (₾). Be reassuring and professional.' }] },
                    contents: [{ role: 'user', parts: [{ text: input }] }]
                  })
                })
                var data = await res.json()
                var reply = data.candidates?.[0]?.content?.parts?.[0]?.text || 'No response'
                s.root.update({ commAiResult: reply, isTyping: false })
              } catch (err) {
                s.root.update({ commAiResult: 'Error: ' + err.message, isTyping: false })
              }
            }
          }
        },
        CommAiResult: {
          show: (el, s) => s.root.commAiResult,
          flow: 'y', gap: 'Z', padding: 'A', round: 'A', background: 'inkSurface', border: '1px solid purple', marginTop: 'A',
          CommResultLabel: { text: '{{ patientFriendly | polyglot }}', fontSize: 'Z', fontWeight: '700', color: 'purple' },
          CommResultText: {
            html: (el, s) => {
              var text = s.root.commAiResult || ''
              return text
                .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
                .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
                .replace(/\n/g, '<br>')
            },
            fontSize: 'Z', color: 'inkSubtle', lineHeight: '1.6'
          }
        }
      }
    },
    MobileTabBar: {}
  }
}
